<template>
  <action-button @clicked="removeFavoriteItem" buttonLabel="Favorited" v-if="pony.inFavorites">
    <font-awesome-icon :icon="['fas', 'heart']" />
  </action-button>
  <action-button @clicked="addFavoriteItem" buttonLabel="Favorite" v-else>
    <font-awesome-icon :icon="['far', 'heart']" />
  </action-button>
</template>

<script>
import { mapActions } from 'vuex';
import ActionButton from '../ActionButton/ActionButton';

export default {
  name: 'FormFavoritePony',
  props: {
    pony: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      errors: []
    };
  },
  components: {
    ActionButton
  },
  methods: {
    ...mapActions('pony', ['TOGGLE_FAVORITE_STATUS']),
    addFavoriteItem() {
      this['TOGGLE_FAVORITE_STATUS']({
        ponyId: this.pony.id,
        inFavorites: true
      });
      this.$emit('added', { item: this.pony })
    },
    removeFavoriteItem() {
      this['TOGGLE_FAVORITE_STATUS']({
        ponyId: this.pony.id,
        inFavorites: false
      });
      this.$emit('removed', { item: this.pony })
    }
  }
};
</script>
